import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ADMIN_SISTEMA } from '../contexts/constants/profiles';

interface ProtectedRouteProps {
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {

  const getRole = () => {
    var role = '';
    var user = localStorage.getItem('user');
    if(user){
      role = JSON.parse(user).rols.description;
    }
    return role;
  }

  const userRole = getRole(); // Suponiendo que el rol se guarda como 'userRole'

  if (!userRole) {
    // Si no hay rol, redirigir a Login
    return <Navigate to="/" />;
  }

  // El Administrador de Sistema (super-admin) tiene acceso a todo.
  if (userRole === ADMIN_SISTEMA) {
    return <Outlet />;
  }

  if (!allowedRoles.includes(userRole)) {
    // Si el rol no está permitido, redirigir a una página de acceso denegado
    return <Navigate to="/access-denied" />;
  }

  return <Outlet />; // Renderiza la ruta protegida
};

export default ProtectedRoute;